import { AxiosResponse } from 'axios';

export function dataCollectionParser(
  response: AxiosResponse<{ data: Record<string, unknown>[] }>
): Record<string, unknown>[] {
  return response.data.data.map(dataParser);
}

export const dataParser = (x: any) => ({
  ...{ id: x.id, type: x.attributes.type ?? x.type },
  ...x.attributes
});
